export const removeTimeFromWorkArea = (workArea: string): string => {
  if (!workArea) return "";
  
  // Matches time patterns in both 24-hour and 12-hour formats
  // const timeRegex = /\b(?: 
  //   // ---- 24-hour or flexible time with optional AM/PM ----
  //   ([01]?\d|2[0-3])     // Hour: 0–23 (e.g., 0–9, 00–19, 20–23)
  //   :                    // Colon separator
  //   [0-5]?\d             // Minutes: 0–59 (allows single digit like 6:5)
  //   (?:\s?[ap]m)?        // Optional AM/PM (e.g., "am", " pm")

  //   |                    // OR

  //   // ---- 12-hour format without colon ----
  //   ([1-9]|1[0-2])       // Hour: 1–12
  //   (?:\s?[ap]m)         // Mandatory AM/PM (e.g., "6 pm", "3pm")
  // )\b/gi;

  const timeRegex = /\b(?:([01]?\d|2[0-3]):[0-5]?\d(?:\s?[ap]m)?|([1-9]|1[0-2])(?:\s?[ap]m))\b/gi;
  return workArea
    // Remove all matched time patterns
    .replace(timeRegex, "")
    // Normalize multiple hyphens (e.g., "---" → " - ")
    .replace(/\s*-\s*-\s*/g, " - ")
    // Remove leading or trailing hyphens
    // e.g., "- Welding -" → "Welding"
    .replace(/^\s*-\s*|\s*-\s*$/g, "")
    // Collapse multiple spaces into a single space
    .replace(/\s{2,}/g, " ")
    // Remove space before punctuation (e.g., "test ." → "test.")
    .replace(/\s+([.,!?;:])/g, "$1")
    // Trim leading/trailing whitespace
    .trim();
}
